import { createSelector } from '@reduxjs/toolkit';

import MenuItemViewModel from '../../services/menu/MenuItemViewModel';
import MenuService from '../../services/menu/MenuService';
import MenuViewModel from '../../services/menu/MenuViewModel';
import UniqueId from '../../services/uid/UniqueId';
import { AppState } from '../reducers/root';

import { getCurrentLocaleName } from './intl';

export const getMenuItem = (store: AppState, id: UniqueId): MenuItemViewModel =>
  store.menu.items[id];

export const getMenuItems = (store: AppState): MenuViewModel['items'] =>
  store.menu.items;

export const getMenuFilter = (store: AppState): string => store.menu.filter;

export const getRootMenuIds = createSelector(getMenuItems, items =>
  Object.values(items)
    .filter(item => item.menuNestinglevel === 0)
    .map(item => item.id)
);

export const getFilteredMenuItems = createSelector(
  [getMenuFilter, getMenuItems, getCurrentLocaleName],
  (filter, items, locale) => new MenuService().filterMenu(filter, items, locale)
);

export const getMenuApplication = (store: AppState): string =>
  store.menu.application;

export const isMenuOpened = (store: AppState): boolean => store.menu.opened;

export const getCurrentOpenedId = (store: AppState): UniqueId | null =>
  store.menu.currentOpenedId;
